import { Outlet, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';

import { AppNavbar } from './app-navbar';
import { TenantSelectionModal } from './tenant-selection-modal.component';
import { useTenants } from '../../../hooks/useTenants';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { selectSessionUser } from '../../../redux';

export function AppLayout() {
  const { allowedTenants, setSelectedTenant, selectedTenant } = useTenants();
  const user = useAppSelector(selectSessionUser);
  const navigate = useNavigate();
  const [showTenantModal, setShowTenantModal] = useState(false);

  useEffect(() => {
    if (selectedTenant) return;

    if (allowedTenants.length > 1) {
      setShowTenantModal(true);
    } else if (allowedTenants.length === 1) {
      setSelectedTenant(allowedTenants[0]);
    }
  }, [allowedTenants.length]);

  const handleCloseModal = useCallback(() => {
    setShowTenantModal(false);
    if (selectedTenant) navigate(0);
  }, [selectedTenant]);

  return (
    <div className="h-full flex flex-col relative bg-background">
      {/* NAVBAR */}
      <AppNavbar />

      {/* CONTENT */}
      <div className="scroll-smooth flex flex-col min-w-0 overflow-y-auto min-h-screen text-gray-900">
        <div className="relative">
          <Outlet />
        </div>
      </div>

      {/* TENANT SELECTION MODAL */}
      <TenantSelectionModal
        allowedTenants={allowedTenants}
        selectedTenant={selectedTenant}
        user={user}
        onClose={handleCloseModal}
        open={showTenantModal}
      />
    </div>
  );
}
